import * as types from './constants';

// Get Performance Creators
export const getPerformanceCreatorsRequest = data => (
  { type: types.GET_PERFORMANCE_CREATORS_REQUEST, payload: data }
);

export const getPerformanceCreatorsDone = data => (
  { type: types.GET_PERFORMANCE_CREATORS_DONE, payload: data }
);

export const getPerformanceCreatorsFailed = errors => (
  { type: types.GET_PERFORMANCE_CREATORS_FAILED, payload: errors }
);

// Operations
export const updateUserPerformanceCreators = data => (
  { type: types.UPDATE_USER_PERFORMANCE_CREATORS, payload: data }
);

export const togglePerformanceCreators = data => (
  { type: types.TOGGLE_PERFORMANCE_CREATORS, payload: data }
);

export const toggleAllPerformanceCreators = data => (
  { type: types.TOGGLE_ALL_PERFORMANCE_CREATORS, payload: data }
);

export const setFilter = data => (
  { type: types.SET_PERFORMANCE_CREATORS_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_PERFORMANCE_CREATORS_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_PERFORMANCE_CREATORS_FILTERS, payload: { filterToUpdate, mobile } }
);

export const performanceCreatorsSetPage = data => (
  { type: types.PERFORMANCE_CREATORS_SET_PAGE, payload: data }
);

export const performanceCreatorsErrorsReset = () => (
  { type: types.PERFORMANCE_CREATORS_ERRORS_RESET }
);

export const performanceCreatorsReset = () => (
  { type: types.PERFORMANCE_CREATORS_RESET }
);